import { memo, useCallback } from "react";
import { SupportedCountryNameTextsConfig } from "@evergiving/common/dist/es2015/form";

import { Text } from "@/lib/components/Text";
import { CountryFlag } from "@/lib/components/CountryFlag";
import { getFlag } from "@/lib/dynamic/countryFlagsForSelector";

export const CountryButton = memo(
  ({
    countryCode,
    onClick,
    selected,
    supportedCountryNameTexts,
  }: {
    countryCode: string;
    onClick: (countryCode: string) => void;
    selected: boolean;
    supportedCountryNameTexts: SupportedCountryNameTextsConfig;
  }) => {
    const handleClick = useCallback(() => {
      onClick(countryCode);
    }, [onClick, countryCode]);

    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ Discussion of this override follows:

    Keyboard events _are_ handled in the parent component, CountryField.

    We force the focus to stay in the input field so that this component
    will never receive keyboard events anyway.

    jsx-a11y isn't smart enough to figure this out, so we need to
    disable the rule here.

    */

    return (
      <li
        id={`country-option-${countryCode}`}
        role="option"
        className="countryChoice"
        onClick={handleClick}
        tabIndex={-1}
        aria-selected={selected || undefined}
      >
        <CountryFlag countryCode={countryCode} getFlag={getFlag} />
        <Text value={supportedCountryNameTexts[countryCode]} />
      </li>
    );

    /* eslint-enable jsx-a11y/click-events-have-key-events */
  }
);
CountryButton.displayName = "CountryButton";
